import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  align-self: stretch;
  align-items: stretch;
  padding: 1rem;
  &:last-of-type {
    padding-top: 0;
  }
`
